export const COMMON_REQ = 'cris/station/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/station/COMMON_REQ_FAIL';

export const LOAD_STATIONS_SUCCESS = 'cris/station/LOAD_STATIONS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	stations: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_STATIONS_SUCCESS:
			const stations = action.payload.data.stations.map((item) => ({
				id: item.id,
				business_unit_id: item.business_unit_id,
				name: item.name,
				businessUnitName: item.business_unit.name,
			}));

			return {
				...state,
				isLoading: false,
				stations: stations
			};

		default:
			return state;
	}
}
